// extracted by mini-css-extract-plugin
export default {"Button":"SquareCard_Button__5kT+B"};